import React from 'react';
import {AsyncComponent} from "../../../../../core/components/router/async-component";

export const FooterModuleAsyncComponent = AsyncComponent(async () => import('./footer-module' /* webpackChunkName: "footer-module" */ ));

export const FooterModuleAsync = (props) => {
  return <React.Suspense fallback={<div/>}>
    <FooterModuleAsyncComponent {...props}/>
  </React.Suspense>
}
